



























































import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop} from 'vue-property-decorator';

import {Level} from '@/model/Notification';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {},
})
export default class NotificationsCenterList extends Mixins<BaseComponent>(BaseComponent) {
  private colorMap: Map<Level, string> = new Map([
    [Level.Success, 'success'],
    [Level.Info, 'info'],
    [Level.Warn, 'warning'],
    [Level.Error, 'error'],
  ]);

  private iconsMap: Map<Level, string> = new Map([
    [Level.Success, 'mdi-check-circle'],
    [Level.Info, 'mdi-information'],
    [Level.Warn, 'mdi-alert'],
    [Level.Error, 'mdi-close-octagon'],
  ]);

  @Prop()
  private notifications!: Notification[];
}
